import { memo, useMemo } from 'react'
import withModuleContext from 'root/src/client/util/withModuleContext'
import dynamic from 'next/dynamic'
import miscModuleConnector
	from 'root/src/client/logic/misc/miscModule/connectors/miscModuleConnector'

const miscModuleTypes = {
	linkPaymentModule: dynamic(() => import('root/src/client/web/misc/LinkPaymentModule')),
	creatorsAutocompleteModule: dynamic(() => import('root/src/client/web/misc/CreatorsAutocompleteModule')),
	agencyPublishersSelect: dynamic(() => import('root/src/client/web/misc/AgencyPublishersSelectModule')),
	helperWidgetModule: dynamic(() => import('root/src/client/web/misc/IfHelperWidgetModule')),
	languageSwitcherModule: dynamic(() => import('root/src/client/web/misc/LanguageSwitcher')),
}

export const MiscModuleUnconnected = memo(({ miscModuleType, ...props }) => {
	const MiscModuleComponent = useMemo(() => (
		miscModuleTypes[miscModuleType]
	), [miscModuleType])

	if (!MiscModuleComponent) {
		return null
	}

	return <MiscModuleComponent {...props} />
})

export default withModuleContext(miscModuleConnector(MiscModuleUnconnected))
